import React, { useEffect, useRef, useState } from 'react';
import NotificationItem from '../NotificationItem';
import Button from '../../Button';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import {
  NotificationWrapper,
  Dropdown,
  ButtonsContainer,
  TopBar,
} from './NotificationDropDown.styled';
import { ASSETS } from '../../../utils/config';
import { LeftBar, NotificationCount } from '../../../pages/Notifications/styles';
import TextView from '../../TextView';
import { Button as MuiButton } from '@mui/material';
import { colors } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setNotifications, markNotificationRead } from '../../../redux/reducers/notifications';
import { markAllRead, markNotificationRead as markNotificationReadApi } from '../../../services/api';
import NotificationsEmptyState from '../EmptyState';
import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_INFINITE_KEY,
  NOTIFICATIONS_UNREAD_KEY,
} from '../useNotifications';

function NotificationDropdown({ onClose }) {
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const notifications = useSelector((state) => state.notifications.data) ?? [];
  const dispatch = useDispatch();
  // This component mutates read-state through services/api directly (not the
  // react-query mutations NotificationCenter uses), so the bell's own caches
  // (the feed + the unread-count badge) never hear about it unless we
  // invalidate them here ourselves — same gap notificationCacheSync.js
  // documents and closes for the /notifications page.
  const queryClient = useQueryClient();
  const [unreadCount, setUnreadCount] = useState(0); // State to track unread notifications
  // P5S1-O12: persist a single row's read state on activation (best-effort).
  const handleActivate = (notification) => {
    if (!notification || notification.is_read) return;
    dispatch(markNotificationRead(notification.id));
    markNotificationReadApi(notification.id)
      .then(() => {
        queryClient.invalidateQueries([NOTIFICATIONS_QUERY_KEY]);
        queryClient.invalidateQueries([NOTIFICATIONS_INFINITE_KEY]);
        queryClient.invalidateQueries([NOTIFICATIONS_UNREAD_KEY]);
      })
      .catch((err) => {
        console.error('Failed to mark notification read:', err);
      });
  };
  const handleMarkRead = async () => {
    // Mark all notifications as read
    // setNotifications((prevNotifications) =>
    //   prevNotifications.map((notification) => ({ ...notification, is_read: true }))
    // );
    try {
      const response = await markAllRead();
      console.log('Read response:', response);

      if (response.data && response.data.success) {
        // console.log('success')
        dispatch(
          setNotifications(
            notifications.map((notification) => ({ ...notification, is_read: true }))
          )
        );
        setUnreadCount(0);
        queryClient.invalidateQueries([NOTIFICATIONS_QUERY_KEY]);
        queryClient.invalidateQueries([NOTIFICATIONS_INFINITE_KEY]);
        queryClient.invalidateQueries([NOTIFICATIONS_UNREAD_KEY]);
      } else {
        console.warn('/marking failed:', response.data);
      }
    } catch (error) {
      console.error('Error marking as read:', error.response ? error.response.data : error.message);
    }
  };
  // 3.8 (measured missing on live web-stg; handler was dead-commented on sandbox
  // a37185cc): dismiss the dropdown when the user clicks anywhere outside it or
  // presses Escape. Standard dropdown behaviour that was absent, so the panel
  // could only be closed by navigating away.
  //
  // We listen on `click` (NOT `mousedown`) deliberately: the bell that opens this
  // panel lives outside the dropdown, so a `mousedown`-based outside-close would
  // fire `onClose()` on the very click the user makes to toggle the bell shut —
  // and the bell's own onClick would then re-open it (a close/re-open flc). With
  // `click`, the bell's toggle handler and this handler both resolve the panel to
  // closed on the same event, so a bell click never re-opens it. The listener is
  // attached in an effect that runs after the opening click has already completed,
  // so it never catches the click that opened the panel.
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <Dropdown ref={dropdownRef} data-testid="notification-dropdown">
      <TopBar>
        <LeftBar>
          <TextView variant="subTitle" style={{ fontWeight: 'bold' }}>
            Notifications
          </TextView>
          <NotificationCount>{unreadCount}</NotificationCount>
        </LeftBar>

        {/* <IconButton>
            <MarkAsUnreadIcon />
          </IconButton> */}
      </TopBar>
      {notifications?.length ? <NotificationWrapper>
        {notifications?.slice(0, 4).map((notification) => (
          <NotificationItem
            key={notification?.id}
            name={notification?.name}
            image={notification?.profile_picture}
            actorProfileImage={notification?.actor_profile_image}
            actorUserId={notification?.actor_user_id}
            actorName={notification?.actor_name}
            wheel={notification?.image}
            text={notification?.description || notification?.title}
            type={notification?.type}
            wheelName={notification?.wheelName}
            time={notification?.time_ago}
            createdAt={notification?.created_at}
            isUnread={!notification?.is_read}
            isDropDown={true}
            wheelId={notification?.ref_id}
            extras={notification?.extras}
            onActivate={() => handleActivate(notification)}
          // wheel={notification.image}
          />
        ))}
      </NotificationWrapper>
        : <NotificationsEmptyState />}
      <ButtonsContainer>
        <MuiButton variant="text" onClick={handleMarkRead}>
          <TextView
            style={{ color: '#123051', cursor: 'pointer' }}
            variant="largeText"
          >
            {' '}
            Mark all as read{' '}
          </TextView>
        </MuiButton>
        <Button
          style={{ backgroundColor: colors.purple }}
          onClick={() => navigate('/notifications')}
        >
          View All
        </Button>
      </ButtonsContainer>
    </Dropdown>
  );
}

export default NotificationDropdown;
